import React from "react";
import {
  ColumnStickyTypes,
  ColumnTypes,
  JustificationTypes,
  optionSubTypes,
  TerritoryList,
} from "../../../util/table-view/TableTypes";
import { Link } from "react-router-dom";
import {
  booleanType,
  PageTableType,
  SubOriginTypes,
  trafficLightLabel,
} from "../../../redux/Types";
import HighlightedText from "../../../util/HighlightedText";
import PlayerRef, { PlayableTypes } from "../../ml-player/PlayerRef/PlayerRef";
import i18next from "i18next";
import { LinkInterestedParties } from "../../../util/preview-element/LinkElement";
import store from "redux/Store";
import { getfilterOptions, userDisplay } from "util/CommonFunc";
import TrafficLightInfoBox from "_module/component/traffic-light-info-box/traffic-light-info-box";
import UserDisplay from "util/UserDisplay";

const col = {
  score: {
    width: 40,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.score,
    sticky: ColumnStickyTypes.left,
    cellRenderer: (rowData) => (
      <strong
        title={
          rowData.scoreExp ? JSON.stringify(rowData.scoreExp) : "Unexplained"
        }>
        {rowData.score || "--"}
      </strong>
    ),
  },
  player: {
    width: 20,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.playerAndThumb,
    sticky: ColumnStickyTypes.left,
    tablePageType: PageTableType.SEARCH_ALBUMS,
    // artworkField: albumFields.prodArtworkUrl.id,
    artworkField: () => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      return albumFields.prodArtworkUrl.id;
    },
    cellProp: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      return {
        artworkProps: {
          alt: `Art work for ${rowData[albumFields.prodName.id]}`,
        },
      };
    },
    cellRenderer: (rowData) => (
      <PlayerRef
        key={rowData.id}
        ariaLabel={`Play album ${rowData.prodName}`}
        item={rowData}
        playableType={PlayableTypes.album}
        popoutFor={PageTableType.SEARCH_ALBUM_TRACKS}
      />
    ),
  },
  // player: {
  //   width: 20,
  //   alignHeader: JustificationTypes.center,
  //   alignCell: JustificationTypes.center,
  //   type: ColumnTypes.player,
  //   sticky: ColumnStickyTypes.left,
  //   tablePageType: PageTableType.SEARCH_ALBUMS,
  //   cellRenderer: (rowData) => (<PlayerRef key={rowData.id} aria-label="Play" item={rowData} playableType={PlayableTypes.album} />)
  // },
  prodArtworkUrl: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.artWorkString,
    tablePageType: PageTableType.SEARCH_ALBUMS,
  },
  selector: {
    width: 18,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.selector,
    sticky: ColumnStickyTypes.left,
    tablePageType: PageTableType.SEARCH_ALBUMS,
  },
  cTags: {
    width: 120,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    type: ColumnTypes.number,
  },
  catNo: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
    // cellRenderer: (rowData) => {
    //   <Link
    //     style={{ textDecoration: "none", color: "#fff" }}
    //     key={rowData.id}
    //     to={`/search/album/${rowData.catNo}`}
    //   >
    //     <strong class="tablesLink">
    //       {HighlightedText(rowData, albumFields.catNo.id)}
    //     </strong>
    //   </Link>
    // },
  },

  territories: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    // type: ColumnTypes.options,
    type: ColumnTypes.territories_selector,
    filterOptions: TerritoryList,
    selectAll: true,
  },

  adminNotes: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },

  adminTags: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },

  ean: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  upc: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  grid: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  barcode: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  trackGenres: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  trackInstruments: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  bbcAlbumId: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  cLine: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  ipRecordLabel: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  musicOrigin: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.options,
    // filterOptions: Object.values(albumOrigins),
    filterOptions: getfilterOptions("mlSearchAlbumCol"),
  },
  trackOrigin: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.options,
    filterOptions: getfilterOptions("mlSearchAlbumTrackCol"),
  },
  musicOriginSubIndicator: {
    width: 140,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.options,
    isFilterable: true,
    isSortable: true,
    explicitOrForAdvSearch: true,
    filterOptions: [
      {
        id: SubOriginTypes.Mcps,
        label: i18next.t(`modules.subOriginLables.Mcps`),
      },
      {
        id: SubOriginTypes.NonMcps,
        label: i18next.t(`modules.subOriginLables.NonMcps`),
      },
    ],
  },

  prodArtist: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.prodArtist.id]
          ? rowData.highlights[albumFields.prodArtist.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="prodArtist"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackPerformer: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackPerformer.id]
          ? rowData.highlights[albumFields.trackPerformer.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackPerformer"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackLyricist: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackLyricist.id]
          ? rowData.highlights[albumFields.trackLyricist.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackLyricist"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackComposerLyricist: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights &&
        rowData.highlights[albumFields.trackComposerLyricist.id]
          ? rowData.highlights[albumFields.trackComposerLyricist.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackComposerLyricist"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackAdaptor: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackAdaptor.id]
          ? rowData.highlights[albumFields.trackAdaptor.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackAdaptor"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackAdministrator: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights &&
        rowData.highlights[albumFields.trackAdministrator.id]
          ? rowData.highlights[albumFields.trackAdministrator.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackAdministrator"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackArranger: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackArranger.id]
          ? rowData.highlights[albumFields.trackArranger.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackArranger"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackComposer: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackComposer.id]
          ? rowData.highlights[albumFields.trackComposer.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackComposer"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackPublisher: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackPublisher.id]
          ? rowData.highlights[albumFields.trackPublisher.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackPublisher"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackOriginalPublisher: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights &&
        rowData.highlights[albumFields.trackOriginalPublisher.id]
          ? rowData.highlights[albumFields.trackOriginalPublisher.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackOriginalPublisher"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackRecordLabel: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  trackSubLyricist: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights &&
        rowData.highlights[albumFields.trackSubLyricist.id]
          ? rowData.highlights[albumFields.trackSubLyricist.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackSubLyricist"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackSubAdaptor: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackSubAdaptor.id]
          ? rowData.highlights[albumFields.trackSubAdaptor.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackSubAdaptor"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackSubArranger: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights &&
        rowData.highlights[albumFields.trackSubArranger.id]
          ? rowData.highlights[albumFields.trackSubArranger.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackSubArranger"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackSubPublisher: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights &&
        rowData.highlights[albumFields.trackSubPublisher.id]
          ? rowData.highlights[albumFields.trackSubPublisher.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackSubPublisher"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackTranslator: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[albumFields.trackTranslator.id]
          ? rowData.highlights[albumFields.trackTranslator.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="trackTranslator"
            type="albums"></LinkInterestedParties>
        </>
      );
    },
  },
  trackTitle: {
    width: 190,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  position: {
    width: 50,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  duration: {
    width: 130,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.number,
    isFilterable: true,
    isSortable: true,
  },
  trackCount: {
    width: 120,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    type: ColumnTypes.number,
    isFilterable: true,
    isSortable: true,
  },
  prodRelease: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.date,
  },
  org_sky_ReleaseDate: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.date,
  },
  id: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  prodName: {
    width: 200,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _albumFields: albumFields },
        },
      } = store.getState();
      return (
        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          key={rowData.id}
          to={{
            pathname: `/search/album/${rowData.prodId}`,
            state: { searchId: rowData.searchId },
          }}
          aria-label={rowData.prodName}>
          <strong class="tablesLink">
            <h3 class="trackAccTitle">
              {" "}
              {HighlightedText(rowData, albumFields.prodName.id)}
            </h3>
          </strong>
        </Link>
      );
    },
  },
  prodSubtitle: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  prodNotes: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  prodYear: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    alignCell: JustificationTypes.right,
    type: ColumnTypes.number,
  },
  prodNumberOfDiscs: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.number,
  },
  prodDiscNr: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  prodTags: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  trackTempo: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  trackBpm: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  trackNumBpm: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  libId: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  prodId: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  libLogoFileName: {
    width: 190,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  libName: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  libNotes: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },

  trackVersionTitle: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  trackMoods: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  trackStyles: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  trackKeywords: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  trackNotes: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  trackIsrc: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  trackPrs: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  trackIswc: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  wsId: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
  },
  charted: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: false,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "True",
      },
      {
        id: booleanType.FALSE,
        label: "False",
      },
    ],
  },
  chartType: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: false,
    type: ColumnTypes.elasticString,
  },

  chartArtist: {
    width: 140,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "True",
      },
      {
        id: booleanType.FALSE,
        label: "False",
      },
    ],
  },
  dateCreated: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.datetime,
  },
  wsName: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  trackPositions: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_trackIsSingleRelease: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
  },
  org_sky_trackSingleReleaseDate: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.date,
  },
  trackDownloadCount: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  trackStreamCount: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_trackSingleChartPosition: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_trackRating: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_trackDecade: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_trackLyrics: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_trackRecordingYear: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  createdBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
    cellProp: (rowData) => ({
      filterProps: {
        ariaLabel: "Select user",
      },
      accessDataProps: {
        title: `${userDisplay(rowData?.createdBy)}`,
      },
    }),
    cellRenderer: (rowData) => <UserDisplay userId={rowData.createdBy} />,
  },
  // lastEditedBy: {
  //   width: 130,
  //   alignHeader: JustificationTypes.left,
  //   isSortable: true,
  //   isFilterable: true,
  //   type: ColumnTypes.users,
  // },
  lastEditedBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
    cellProp: (rowData) => ({
      filterProps: {
        ariaLabel: "Select user",
      },
      accessDataProps: {
        title: `${userDisplay(rowData?.lastEditedBy)}`,
      },
    }),
    cellRenderer: (rowData) => <UserDisplay userId={rowData.lastEditedBy} />,
  },
  trackWithAudio: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  contactDetails: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_trackVocal: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  trackTracfficLight: {
    width: 20,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.options,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    explicitOrForAdvSearch: true,
    // filterOptions: trafficLightLabel,
    extentedProps: "trackskyTracfficLight",
  },
  prsPriorApprovalIndecator: {
    width: 20,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.options,
    isFilterable: true,
    isSortable: true,
  },
  trackDuration: {
    width: 40,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.number,
    isFilterable: true,
    isSortable: true,
  },
  trackArea: {
    width: 40,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.string,
    isFilterable: true,
    isSortable: true,
  },
  org_sky_prodMisc1: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodMisc2: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodLabel: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodCountry: {
    width: 100,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  // trackMCPSID: {
  //   width: 130,
  //   alignHeader: JustificationTypes.left,
  //   isSortable: true,
  //   isFilterable: true,
  //   type: ColumnTypes.boolean,
  //   filterOptions: [
  //     {
  //       id: booleanType.TRUE,
  //       label: "True",
  //     },
  //     {
  //       id: booleanType.FALSE,
  //       label: "False",
  //     },
  //   ],
  // },
  trackPrsPriorApprovalIndecator: {
    width: 20,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.options,
    subType: optionSubTypes.optionWithColor,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    explicitOrForAdvSearch: true,
    filterOptions: trafficLightLabel.map((item) => {
      return { id: item.id, label: item.desc };
    }),
    cellRenderer: (rowData) => {
      if (
        rowData &&
        (rowData.prsPriorApprovalIndecator ||
          rowData.prsPriorApprovalIndecator == 1)
      ) {
        return (
          <>
            <TrafficLightInfoBox
              PriorApproval={
                rowData.prsPriorApprovalIndecator
              }></TrafficLightInfoBox>
          </>
        );
      }
    },
  },
  albumNotes: {
    width: 200,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: true,
    type: ColumnTypes.virtualString,
    searchFields: [
      "org_sky_LibrarianNotes",
      "org_sky_NotableUses",
      "prodNotes",
    ],
    sortFields: ["trackNotes"],
  },
  org_sky_AlbumTypeID: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.options,
    filterOptions: [
      { id: "0", label: "-" },
      { id: "1", label: "Studio" },
      { id: "2", label: "Live" },
      { id: "3", label: "Best of" },
      { id: "4", label: "Compilation" },
      { id: "5", label: "B-Sides" },
      { id: "6", label: "Rare Tracks" },
      { id: "7", label: "Single" },
      { id: "8", label: "Other" },
      { id: "9", label: "Music Library Compilation" },
      { id: "10", label: "Library" },
      { id: "11", label: "Film Score" },
      { id: "12", label: "Internal Compilation" },
      { id: "13", label: "Soundtrack" },
      { id: "14", label: "Specially Commissioned" },
    ],
  },
  trackAllNotes: {
    width: 200,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: true,
    type: ColumnTypes.virtualString,
  },
  org_sky_Vocal: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_LabelWebsite: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Company: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_Publisher: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
    canCloud: true,
  },
  org_sky_CompanyDetails: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_PublisherDetails: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_ArtistWebsite: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_ArtistSocialWebsite: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_ChartPosition: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_IsMCPSBlanket: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "Yes",
      },
      {
        id: booleanType.FALSE,
        label: "Non-MCPS",
      },
    ],
  },
  org_sky_IsPPLBlanket: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "Yes",
      },
      {
        id: booleanType.FALSE,
        label: "Non-PPL",
      },
    ],
  },
  org_sky_TownCityState: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Country: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_NumberMedia: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_LibrarianNotes: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Plugger1: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_catNo2: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_catNo3: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Misc1: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Misc2: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_trackMisc1: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_trackMisc2: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_IsLibraryRecommended: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "True",
      },
      {
        id: booleanType.FALSE,
        label: "False",
      },
    ],
  },
  org_sky_trackMCPS: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "No",
      },
      {
        id: booleanType.FALSE,
        label: "Yes",
      },
    ],
  },
  org_sky_trackPPL: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "No",
      },
      {
        id: booleanType.FALSE,
        label: "Yes",
      },
    ],
  },
  org_sky_trackDownloadAvailable: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "True",
      },
      {
        id: booleanType.FALSE,
        label: "False",
      },
    ],
  },
  org_sky_trackIsLibraryRecommended: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "True",
      },
      {
        id: booleanType.FALSE,
        label: "False",
      },
    ],
  },
  org_sky_trackCountry: {
    width: 40,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.string,
    isFilterable: true,
    isSortable: true,
  },
  org_sky_trackLibrarianNotes: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  downloader: {
    width: 15,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.objectDownloader,
    sticky: ColumnStickyTypes.left,
    tablePageType: PageTableType.SEARCH_TRACKS,
    extentedProps: "trackDownloader",
  },
  strTrackRecordLabel: {
    width: 120,
    alignHeader: JustificationTypes.left,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  numPosition: {
    width: 50,
    alignHeader: JustificationTypes.left,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.number,
  },
  trackDateCreated: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.datetime,
  },
  trackCreatedBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
  },
  trackLastEditedBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
    cellProp: (rowData) => ({
      filterProps: {
        ariaLabel: "Select user",
      },
      accessDataProps: {
        title: `${userDisplay(rowData?.trackLastEditedBy)}`,
      },
    }),
    cellRenderer: (rowData) => (
      <UserDisplay userId={rowData.trackLastEditedBy} />
    ),
  },
  catNoSearch: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: true,
    type: ColumnTypes.virtualIdentity,
  },
  albumIds: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.virtualIdentity,
  },
  trackAllIds: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: true,
    type: ColumnTypes.virtualIdentity,
  },
  trackArid: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  trackMCPSID: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
  },
  trackDhTrackId: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
  },
  trackTrackId: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
  },
  strTrackPerformer: {
    width: 160,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  strTrackComposer: {
    width: 160,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  strTrackPublisher: {
    width: 160,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_trackNotableUses: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  archived: {
    width: 110,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: false,
    discretable: false,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "True",
      },
      {
        id: booleanType.FALSE,
        label: "False",
      },
    ],
  },
  dateLastEdited: {
    width: 150,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  menu: {
    width: 30,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.menu,
    sticky: ColumnStickyTypes.right,
    tablePageType: PageTableType.SEARCH_ALBUMS,
  },
};

export default col;
